import { gql } from "@apollo/client";

export default gql`
  mutation deletePosInvoice($_id: String) {
    deletePosInvoice(_id: $_id) {
      ok
      message
      error
    }
  }
`;
